/** @format */

// const _ = require('underscore');

export const newPlatformResellerConstants = {
    NEW_PLATFORM_RESELLER_LIST: 'new_platform_reseller_list',
    NEW_PLATFORM_RESELLER_ITEM: 'new_platform_reseller_item',
    NEW_PLATFORM_RESELLER_EDIT: 'new_platform_reseller_edit',
    NEW_PLATFORM_RESELLER_DELETE: 'new_platform_reseller_delete',
    NEW_PLATFORM_RESELLER_MANAGE: 'new_platform_reseller_manage',
    NEW_PLATFORM_RESELLER_ADD: 'new_platform_reseller_add',
    NEW_PLATFORM_RESELLER_SELECTED_LIST: 'new_platform_reseller_selected_list',
    NEW_PLATFORM_RESELLER_POOLS: 'new_platform_reseller_pools',
};
